import { FC } from 'react'

import { Skeleton, Spacer } from '@syconium/little-miss-figgy'

import { DeleteIconColumn } from '../PriceAndDeleteButton/styles'

import { Body, Details, DetailsColumn, DetailsRow, ImageWrapper, Top } from './styles'

// Mirrors `RegularCartItem` while the line's product data loads
export const CartLinePlaceholder: FC<{ isBundleGroup?: boolean }> = ({ isBundleGroup }) => (
  <Body aria-hidden data-testid='cart-item-placeholder' $isBundleGroup={isBundleGroup}>
    <Top>
      <ImageWrapper>
        <Skeleton animated height='100px' width='100px' />
      </ImageWrapper>
      <Details>
        <DetailsRow>
          <Skeleton animated height='18px' maxWidth='180px' />
          <DeleteIconColumn>
            <Skeleton animated height='20px' width='20px' />
          </DeleteIconColumn>
        </DetailsRow>
        <Spacer height={4} />
        <DetailsRow $hasOffsetBelow>
          <Skeleton animated height='16px' maxWidth='120px' />
        </DetailsRow>
        <Spacer height={16} />
        <DetailsRow>
          <Skeleton animated height='28px' width='98px' />
          <DetailsColumn>
            <Skeleton animated height='18px' width='48px' />
          </DetailsColumn>
        </DetailsRow>
      </Details>
    </Top>
  </Body>
)
